import { memo } from "react";
import { Stack } from "~/common/mui";
import { SALES_REP_PHONE_NO } from "~/utils/constants";
import { Trans, useTranslation } from "react-i18next";
import DisclaimerCountryOrigin from "~/domains/product/components/DisclaimerCountryOrigin";
import { URL_CONTACT_US } from "~/utils/url/staticUrls";
import { useSelector } from "react-redux";
import { IncludesSurchargeDisclaimer } from "~/domains/pricing/components/IncludesSurchargeDisclaimer";
import {
  selectCartContainsSurcharge,
  selectCartContainsTariffSurcharge,
} from "~/features/cart/cart/redux/selectors/cartSelectors";
import { Alert } from "~/common/mui/Alert/Alert";

export const CHECKOUT_DISCLAIMER_ID = "disclaimer";
const CheckoutFooter = () => {
  const hasAnySurcharge = useSelector(selectCartContainsSurcharge);
  const hasAnyTariffSurcharge = useSelector(selectCartContainsTariffSurcharge);

  const { t } = useTranslation();

  return (
    <div id={CHECKOUT_DISCLAIMER_ID} className={"mt-30"}>
      <Stack direction="column" gap={1.25}>
        <DisclaimerCountryOrigin />
        <Alert severity="info">
          <Trans i18nKey="checkoutPage.disclaimer.two">
            Need help with your checkout process?
            <a href={URL_CONTACT_US} target="_blank">
              Contact us
            </a>
            or call phone number {{ phoneNo: SALES_REP_PHONE_NO }}
          </Trans>
        </Alert>
      </Stack>
      {
        <IncludesSurchargeDisclaimer
          hasSurcharge={hasAnySurcharge}
          tariffSurcharge={hasAnyTariffSurcharge}
          className={"mt-30"}
        />
      }
    </div>
  );
};

export default memo(CheckoutFooter);
